// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../fonts/fake-receipt.ttf");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "@font-face{font-family:\"Fake Receipt\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");font-style:normal;font-weight:400}", ""]);
// Exports
module.exports = exports;
